import React from 'react';
import { Product } from '~/lib/data-contract/salesforce';
import { DeliveryDaysText, Link } from '~/shared/components';
import {
    StyledProductInfoBrand,
    StyledProductInfoDetails,
    StyledProductInfoMaterial,
    StyledProductInfoTitle,
    StyledProductInfoFootnotes,
    StyledProductPersonalization,
} from '../styled';
import useProductPersonalization from '~/services/personalization/useProductPersonalization';

type Props = {
    lineItem: Product;
    onProductClick: (product: Product, index: number) => void;
    index: number;
};
export const ProductDetails = ({ lineItem, onProductClick, index }: Props) => {
    const {
        shouldAllowPersonalization,
        personalizationMetadataEntries,
        personalizationTitleWithPrice,
    } = useProductPersonalization(lineItem);

    const shouldShowPersonalizationDetails =
        shouldAllowPersonalization && !!personalizationMetadataEntries;

    return (
        <StyledProductInfoDetails>
            <Link
                onClick={() => onProductClick(lineItem, index)}
                href={lineItem.c_pageURL}
                title={lineItem.productName}
            >
                <StyledProductInfoBrand>{lineItem.brand}</StyledProductInfoBrand>
                <StyledProductInfoTitle>{lineItem.productName}</StyledProductInfoTitle>
                <StyledProductInfoMaterial>{lineItem?.c_synopsis}</StyledProductInfoMaterial>

                {shouldShowPersonalizationDetails && (
                    <StyledProductPersonalization>
                        {personalizationTitleWithPrice && (
                            <p>
                                <strong>{personalizationTitleWithPrice}</strong>
                            </p>
                        )}

                        {personalizationMetadataEntries.map((entry) => (
                            <p key={entry.key}>
                                {entry.key}: <em>{entry.value}</em>
                            </p>
                        ))}
                    </StyledProductPersonalization>
                )}

                {lineItem?.c_deliveryDaysText ? (
                    <StyledProductInfoFootnotes>
                        <DeliveryDaysText product={lineItem} highlighted />
                    </StyledProductInfoFootnotes>
                ) : null}
            </Link>
        </StyledProductInfoDetails>
    );
};
